import { inject, Injectable } from '@angular/core';
import { MarketGroup } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MarketDashboardSignalStore } from '../+state/market-dashboard-signal.store';
import { MarketGroupDataService } from '../infrastructure/group.data.service';
import { MarketDashboardNormalizerService } from '../infrastructure/market-dashboard-normalizer.service';

@Injectable()
export class GroupFacade {
  private service = inject(MarketGroupDataService);
  private store = inject(MarketDashboardSignalStore);
  private normalizer = inject(MarketDashboardNormalizerService);

  add$(input: MarketGroup) {
    return this.service.add$(input).pipe(
      tap((response: MarketGroup) => {
        const group = {
          ...input,
          id: response.id,
        };

        this.store.upsertGroup(this.normalizer.normalizeGroup(group));
      }),
    );
  }

  update$(input: MarketGroup) {
    return this.service
      .update$(input)
      .pipe(
        tap((response: MarketGroup) =>
          this.store.upsertGroup(this.normalizer.normalizeGroup(response)),
        ),
      );
  }

  getAll$(columnId: ID): Observable<MarketGroup[]> {
    return this.service.getAll$(columnId);
  }

  getById$(_id: ID) {
    return this.service.getById$(_id);
  }

  delete$(_id: ID) {
    return this.service
      .delete$(_id)
      .pipe(tap(() => this.store.removeGroup(_id)));
  }
}
